import React from "react"
import { Modal as MUIModal, Card } from "@mui/material"
import { CardProps } from "@mui/material/Card"
import { styled } from "@mui/material/styles"

interface ModalProps {
  open: boolean
  bgClose?: boolean
  fullheight?: boolean | string
  float?: boolean
  solidBg?: boolean
  background?: "default" | "paper"
  children: JSX.Element
}

interface CustomCardProps extends CardProps {
  fullheight?: boolean | string
  background?: "default" | "paper"
}

// top: 50%;
// left: 50%;
// transform: translate(-50%, -50%);

const StyledCard = styled(Card)<CustomCardProps>(
  ({ theme, fullheight, background }) => `
position: absolute;
bottom: 0;
width: 100%;
height: max-content;
background-color: ${
    background
      ? theme.palette.background[background]
      : theme.palette.background.paper
  } ;
box-shadow: 0px 0px 5px rgba(0,0,0, 0) !important;
padding: 24px 16px 48px 16px;
max-height: 90vh;
min-height: ${fullheight === "true" ? "90vh" : null} ;

${theme.breakpoints.up("sm")}{ 
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  max-width: 600px;
   
  }

&::-webkit-scrollbar {
  width: 5px; 
  margin: -10px;
}

  /* Track */
&::-webkit-scrollbar-track {
  background: none;
  border-radius: 10px;
}

/* Track on hover */
&::-webkit-scrollbar-track:hover {
  background: #f1f1f1;
}

/* Handle */
&::-webkit-scrollbar-thumb {
  background: none;
  border-radius: 10px;
}

/* Handle on hover */
&::-webkit-scrollbar-thumb:hover {
  background: ${theme.palette.primary.main};
}

`
)

const StyledFloatingCard = styled(Card)<CustomCardProps>(
  ({ theme, fullheight, background }) => `

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  overflow-y: scroll;
  background-color: ${
    background
      ? theme.palette.background[background]
      : theme.palette.background.paper
  } ;
  box-shadow: 0px 0px 5px rgba(0,0,0, 0) !important;
  padding: 24px 16px 48px 16px;
  max-height: 90vh;
  min-height: ${fullheight === "true" ? "90vh" : null} ;

${theme.breakpoints.up("sm")}{ 
  max-width: 600px;

  }

 

&::-webkit-scrollbar {
  width: 5px; 
  margin: -10px;
}

  /* Track */
&::-webkit-scrollbar-track {
  background: none;
  border-radius: 10px;
}

/* Track on hover */
&::-webkit-scrollbar-track:hover {
  background: #f1f1f1;
}

/* Handle */
&::-webkit-scrollbar-thumb {
  background: none;
  border-radius: 10px;
}

/* Handle on hover */
&::-webkit-scrollbar-thumb:hover {
  background: ${theme.palette.primary.main};
}
`
)

export const Modal = ({
  open,
  bgClose,
  fullheight,
  float = false,
  solidBg,
  background = "paper",
  children,
}: ModalProps) => {
  const [opened, setOpened] = React.useState(open)

  React.useEffect(() => {
    setOpened(open)
  }, [open])

  const handleClose = () => setOpened(false)

  return (
    <MUIModal
      open={opened}
      onClose={bgClose ? handleClose : () => true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: {
          sx: (theme) => ({
            backgroundColor: solidBg ? theme.palette.primary.main : null,
          }),
        },
      }}
    >
      {float ? (
        <StyledFloatingCard
          fullheight={`${fullheight}`}
          background={background}
        >
          {children}
        </StyledFloatingCard>
      ) : (
        <StyledCard fullheight={`${fullheight}`} background={background}>
          {children}
        </StyledCard>
      )}
    </MUIModal>
  )
}

export default Modal
